import { render } from "./tab-nav.vue?vue&type=template&id=79cc6ec1"
import script from "./tab-nav.vue?vue&type=script&lang=js"
export * from "./tab-nav.vue?vue&type=script&lang=js"

import "./tab-nav.vue?vue&type=style&index=0&id=79cc6ec1&lang=postcss"
script.render = render

export default script